import React from 'react';
import { TSymbolProp } from './consts';
import createReactContext from '../createReactContext';
import createConnectLocale from './createConnectLocale';

const { withLocale, LocaleProvider, useLocale } = createConnectLocale(
  React.createContext || createReactContext
);

export { withLocale, LocaleProvider, useLocale, TSymbolProp };
